export type BrowserFamily = 'chromium' | 'firefox' | 'safari' | 'unknown';

export function detectBrowserFamily(userAgent: string = navigator.userAgent): BrowserFamily {
  const ua = userAgent.toLowerCase();

  if (ua.includes('firefox')) return 'firefox';
  if (ua.includes('safari') && !ua.includes('chrome') && !ua.includes('crios') && !ua.includes('edg')) {
    return 'safari';
  }
  if (ua.includes('chrome') || ua.includes('crios') || ua.includes('edg')) return 'chromium';

  return 'unknown';
}

interface RetryHintInput {
  browser: BrowserFamily;
  errorName?: string;
  elapsedMs: number;
}

/**
 * Keep this heuristic simple:
 * - Chromium instant NotAllowedError generally means previously blocked site permission.
 * - Safari/Firefox are more likely to allow re-prompting after retry/reload.
 */
export function getMicPermissionRetryHint({ browser, errorName, elapsedMs }: RetryHintInput): string {
  if (browser === 'chromium' && errorName === 'NotAllowedError' && elapsedMs < 400) {
    return 'Microphone is blocked for this site. Click the lock icon in your address bar and allow microphone access, then retry.';
  }

  if (browser === 'firefox') {
    return 'If the permission prompt appears, allow microphone access and click Enable Access again.';
  }

  if (browser === 'safari') {
    return 'Safari may require another attempt. Retry, or open Safari website settings and allow microphone access.';
  }

  return 'Please enable microphone permissions in your browser settings, then click Enable Access again.';
}
